import { IState } from "./index";

export const initialState: IState = {
  apiCallInProgress: 0,
  offerLetterLoginDetails: {
    access_token: "",
    countryID: "",
    cultureCode: "",
    expires_in: 0,
    isCompany: false,
    isFirstTimePasswordChanged: true,
    isPolicyAccepted: true,
    isValidCustomerInfo: true,
    loginflow: "",
    refreshToken_timeout: "",
    refresh_token: "",
    token_type: "",
    userName: "",
    userTypeId: 0,
    webUserId: 0,
    responsecode: "000",
    body: {},
  },
  isSuccess: false,
  baseResponse: undefined,
};
